<template>
	<div class="fullWidth">
		<div v-if="paymentInfo.length === 0" class="ordersEmpty">
			<br />
			<figure class="about-img2 img-wrapper">
				<img src="../assets/static/images/illustrations/invoices.svg" />
			</figure>
			<h2 v-if="noData">{{ $t('noMonthPayments') }}</h2>
			<h2 v-else>{{ $t('obPayments') }}</h2>
		</div>

		<div v-else class="ordersReceived">
			<v-container class="grey lighten-5">
				<v-row no-gutters>
					<v-col sm="3" md="3" xs="6"> {{ $t('filterByMonths') }} </v-col>
					<v-col sm="3" md="3" xs="6">
					<vue-monthly-picker
						v-model="defaultDate"
						:min="min"
						:max="max"
						alignment="center"
						selectedBackgroundColor="#fb7377"
						:clearOption="false"
						:monthLabels="monthLabels"
						@selected="filterInvoices"
						:placeHolder="$t('selectMonth')"
					>
					</vue-monthly-picker>
					</v-col>
					<div class="downloadBtn">
						<div class="downloadBtn1">
							<button
								class="zip-btn"
								@click="downloadZip"
								:disabled="!month || !year || this.noData"
							>
								<i class="fas fa-file-archive"></i>
								{{ $t('downloadInvoices') }}
							</button>
						</div>
						<div>
							<button
								class="zip-btn"
								@click="downloadVATReport"
								:disabled="!month || !year || this.noData"
							>
								<i class="fas fa-file"></i>
								{{ $t('vatReport') }}
							</button>
						</div>
					</div>
				</v-row>

				<v-row no-gutters>
				<!-- <v-col cols="12" sm="4" md="4">
					<v-card class="pa-2" outlined tile>
					<div>
						<h3 class="metricsInitals">AOV</h3>
						<VueJsCounter class="metricsNo" start="1" end="51"></VueJsCounter>
						<span class="metricsUnit">EUR</span>
						<AovChartClient/>
						<p class="metricsDesc">tracks the average amount spent each time a customer places an order</p>
						</div>
					</v-card>
				</v-col> -->
				<v-col cols="12" sm="12" md="12">
					<v-card class="pa-2" outlined tile>
					<div>
						<section v-if="errored">
						<p>{{ $t('fetchError') }}</p>
						</section>
						<section v-else>
						<div v-if="loading">{{ $t('loading') }}</div>
						<!-- Responsive & Accessible Data Table  -->
						<div v-else class="container">
							<table class="responsive-table">
							<thead>
								<tr>
								<th scope="col"># {{ $tc('order', 2) }}</th>
								<th scope="col">{{ $tc('unit', 1) }}</th>
								<th scope="col">{{ $t('purchasedItem') }}</th>
								<th scope="col">{{ $t('quantity') }}</th>
								<th scope="col">{{ $t('amount') }}</th>
								<th scope="col">{{ $t('transactionTime') }}</th>
								<th scope="col"></th>
								</tr>
							</thead>
							<tbody v-if="$isMobile()">
								<tr
								v-for="paymentInfo in paymentInfo"
								v-bind:key="paymentInfo"
								>
								<Collapsible :isOpen="false">
									<div slot="trigger">
									<th scope="row">
										{{ clientId }}_{{ paymentInfo.orderId }}
										<span v-if="paymentInfo.transactionTime">
										/
										{{
											paymentInfo.transactionTime | formatDate
										}}</span
										>
										<i class="fas fa-caret-up right"></i>
									</th>
									</div>
									<div slot="closedTrigger">
									<th scope="row">
										{{ clientId }}_{{ paymentInfo.orderId }}
										<span v-if="paymentInfo.transactionTime">
										/
										{{
											paymentInfo.transactionTime | formatDate
										}}</span
										>
										<i class="fas fa-caret-down right"></i>
									</th>
									</div>
									<!-- <div slot="closedTrigger"> -->
									<td :data-title="$tc('unit', 1)">
									{{ paymentInfo.unitName }}
									</td>
									<td :data-title="$t('purchasedItem')">
									<div
										v-for="(item, index) in paymentInfo.products"
										:key="index"
									>
										{{ item.productName }}
									</div>
									</td>
									<td :data-title="$t('quantity')">
									<div
										v-for="(item, index) in paymentInfo.products"
										:key="index"
									>
										{{ item.quantity }}
									</div>
									</td>
									<td :data-title="$t('amount')">
									{{ paymentInfo.amount }} EUR
									</td>
									<td :data-title="$t('transactionTime')">
									{{ paymentInfo.transactionTime | formatDate }}
									</td>
									<td>
									<a
										v-if="paymentInfo.invoicePDF"
										@click="downloadPDF(paymentInfo.cebelcaInvoiceId)"
									>
										<div class="trashIcon">
										<font-awesome-icon
											class="icon"
											icon="download"
										/>
										</div>
									</a>
									</td>
									<!-- </div> -->
								</Collapsible>
								</tr>
							</tbody>
							<tbody v-else>
								<tr
								v-for="paymentInfo in paymentInfo"
								v-bind:key="paymentInfo"
								>
								<th scope="row">{{ clientId }}_{{ paymentInfo.orderId }}</th>
								<td :data-title="$tc('unit', 1)">
									{{ paymentInfo.unitName }}
								</td>
								<td :data-title="$t('purchasedItem')">
									<div
									v-for="(item, index) in paymentInfo.products"
									:key="index"
									>
									{{ item.productName }}
									</div>
								</td>
								<td :data-title="$t('quantity')">
									<div
									v-for="(item, index) in paymentInfo.products"
									:key="index"
									>
									{{ item.quantity }}
									</div>
								</td>
								<td :data-title="$t('amount')">
									{{ paymentInfo.amount }} EUR
								</td>
								<td :data-title="$t('transactionTime')">
									{{ paymentInfo.transactionTime | formatDate }}
								</td>
								<td>
									<a
									v-if="paymentInfo.invoicePDF"
									@click="downloadPDF(paymentInfo.cebelcaInvoiceId)"
									>
									<div class="trashIcon">
										<font-awesome-icon
										class="icon"
										icon="download"
										/>
									</div>
									</a>
								</td>
								</tr>
							</tbody>
							</table>
						</div>
						</section>
						<!------------------------------------>
					</div>
					</v-card>
				</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import VueMonthlyPicker from 'vue-monthly-picker'
import 'vue-collapsible-component/lib/vue-collapsible.css'
import Collapsible from 'vue-collapsible-component'
import PaymentService from '@/services/PaymentService.js'
import CebelcaService from '@/services/CebelcaService.js'
// import VueJsCounter from 'vue-js-counter'
// import AovChartClient from '@/components/charts/AovChartClient.vue';

// import ProductService from '@/services/ProductService.js'
//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  metaInfo() {
    return {
      title: this.$i18n.tc('payment', 2),
    }
  },
  components: {
    VueMonthlyPicker,
    Collapsible,
    // VueJsCounter
    // AovChartClient
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const utcDate = new Date(value)
        if (isNaN(utcDate.getTime())) return value
        // Get local time zone offset in milliseconds
        const localOffset = new Date().getTimezoneOffset() * 60000
        // Convert UTC time to local time
        const localTime = new Date(utcDate.getTime() - localOffset)
        return moment(String(localTime)).format('HH:mm DD-MMM-YYYY')
      } else {
        return value
      }
    },
  },
  data() {
    return {
      isLoading: true,
      paymentInfo: [],
      loading: true,
      errored: false,
      id: this.client.id, //! sql: "DELETE from clients WHERE id = 'undefined'"
      monthLabels: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      defaultDate: '',
      min: moment('01 / 01 / 2021'),
      max: moment(),
      month: 0,
      year: 0,
      noData: false,
      clientId: null
    }
  },
  mounted() {
    this.fetchInvoicesData()
    const user = JSON.parse(localStorage.getItem('user'));
    this.clientId = user.id
  },
  methods: {
    filterInvoices(value) {
      this.month = value.format('M')
      this.year = value.format('YYYY')
      this.fetchInvoicesData()
    },
    fetchInvoicesData() {
      PaymentService.fetchFilteredInvoices(this.month, this.year)
        .then((response) => {
          this.noData = false
          this.paymentInfo = response.data
          if (this.paymentInfo.length === 0 && this.month && this.year)
            this.noData = true
        })
        .catch(() => {
          this.errored = true
        })
        .finally(() => (this.loading = false))
    },
    downloadPDF(cebelcaInvoiceId) {
      CebelcaService.fetchInvoicePDF(cebelcaInvoiceId)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')
          
          fileLink.href = fileURL
          fileLink.setAttribute('download', 'Invoice.pdf')
          document.body.appendChild(fileLink)
          
          fileLink.click()
        })
    },
    downloadZip() {
      PaymentService.fetchInvoiceZip({ month: this.month, year: this.year })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')

          link.href = fileURL
          link.setAttribute(
            'download',
            `ExpAR_Invoices-${this.monthLabels[this.month - 1]}${this.year}.zip`
          )
          document.body.appendChild(link)

          link.click()
        })
        .catch((error) => {
          throw error
        })
    },
    downloadVATReport() {
      PaymentService.fetchVATReport({ month: this.month, year: this.year })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')

          link.href = fileURL
          link.setAttribute(
            'download',
            `VAT Report.csv`
          )
          document.body.appendChild(link)

          link.click()
        })
        .catch((error) => {
          throw error
        })
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.ordersEmpty {
  // display: none; //! none when FIRST order with this client_id is already found in db //
}
.ordersReceived {
  // display: none; //! none when NO order with this client_id is found in db //
}

.fullWidth {
	width: 100%;
}

.right {
  float: right;
}

// Breakpoints
$bp-maggie: 15em;
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

// Styles
// * {
//   @include box-sizing(border-box);

//   &:before{
//     @include box-sizing(border-box);
//   }
//   &:after {
//     @include box-sizing(border-box);
//   }
// }

// body {
//   font-family: $helvetica;
//   color: rgba(94,93,82,1);
// }

a {
  color: var(--primary);

  &:hover,
  &:focus {
    color: var(--primary);
  }
}

a:hover {
  text-decoration: none !important;
}

.zip-btn {
  background: var(--primary);
  color: var(--bright);
  text-transform: uppercase;
  padding: 10px 20px;
  font-size: 1.2em;

  @media (min-width: $bp-bart) {
    // right: 10px;
    // position: absolute;
  }
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.metricsNo {
  font-size: 4em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}
.metricsUnit {
  font-size: 1.5em;
}
.metricsInitals {
  font-weight: 400;
  font-size: 2.7em;
  padding-left: 0px;
  letter-spacing: 2px;
}
.metricsDesc {
  font-size: 1em;
}

.container {
  // margin: 5% 3%;

  @media (min-width: $bp-bart) {
    // margin: 2%;
  }

  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;

  @media (min-width: $bp-bart) {
    font-size: 0.9em;
  }

  @media (min-width: $bp-marge) {
    font-size: 1em;
  }

  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px;
    width: 1px;
    overflow: hidden;

    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }

    th {
      background-color: var(--bg-light);
      border: 1px solid var(--bg-light);
      font-weight: normal;
      text-align: center;
      color: var(--bright);

      &:first-of-type {
        text-align: left;
      }
    }
  }

  .trashIcon {
    background: var(--grey);
    color: var(--bright);
    padding: 0.3em;
    letter-spacing: 3px;
    border: none;
    border-radius: 3.5px;
    width: 35px;
    height: 35px;
    right: 0;
    position: relative;
  }

  .icon {
    font-size: 1.3em;
    padding: 1px;
  }

  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }

  tr {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row;
    }
  }

  th,
  td {
    padding: 0.5em;
    vertical-align: middle;

    @media (min-width: $bp-lisa) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-cell;
      padding: 0.5em;
    }

    @media (min-width: $bp-marge) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-homer) {
      padding: 0.75em;
    }
  }

  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;

    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }

  tfoot {
    font-size: 0.8em;
    font-style: italic;

    @media (min-width: $bp-marge) {
      font-size: 0.9em;
    }
  }

  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row-group;
    }

    tr {
      margin-bottom: 1em;

      @media (min-width: $bp-bart) {
        // Undo display: block
        display: table-row;
        border-width: 1px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94, 93, 82, 0.1);
        }
      }
    }

    th[scope='row'] {
      background-color: var(--bg-light);
      color: white;

      @media (min-width: $bp-lisa) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
      }

      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94, 93, 82, 1);
        text-align: left;
      }
    }

    td {
      text-align: right;

      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
        text-align: center;
      }

      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid var(--bg-light);
        }
      }
    }

    td[data-type='currency'] {
      text-align: right;
    }

    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: 0.8em;
      color: rgba(94, 93, 82, 0.75);

      @media (min-width: $bp-lisa) {
        font-size: 0.9em;
      }

      @media (min-width: $bp-bart) {
        // Don’t show data-title labels
        content: none;
      }
    }
  }
}

/* ----  Responsiveness   ----  */
@media (min-width: 481px) {
.downloadBtn {
	display: inherit;
	margin-left: 50px;
}
.downloadBtn1 {
  margin-right: 15px;
}
}

@media (max-width: 480px) {
.downloadBtn {
	display: block;
	margin: 10px auto;
}
.downloadBtn1 {
  margin-bottom: 15px;
}
}
</style>